<script>
  import { status } from "./status.js";
  import { handleCancel, handleConfirm} from "./notification.js";
  import Login from "./Login.svelte";
  import Landing from "./Landing.svelte";
  import DocumentationEnglish from "./DocumentationEnglish.svelte";
  import DocumentationSpanish from "./DocumentationSpanish.svelte";
  import Header from "./component/Header.svelte";
  import Footer from "./component/Footer.svelte";
  import NotFound from "./NotFound.svelte";
  import Services from "./Services.svelte";
  import Users from "./Users.svelte";
  import Registration from "./Registration.svelte";
  import Credentials from "./Credentials.svelte";
  import page from "page";
  import Notification from "./component/Notification.svelte";
  import KillSubscription from "./KillSubscription.svelte";
  import Privacy from './Privacy.svelte';
  import Terms from './Terms.svelte'

  status.useLocalStorage();
  let currentPage;

  function loadPage(component, pageJSContext) {
    $status.path = pageJSContext.path;
    currentPage = component;
  }

  page("/", ctx => loadPage(Landing, ctx));
  page("/login", ctx => loadPage(Login, ctx));
  page("/services", ctx => loadPage(Services, ctx));
  page("/documentation", ctx => {
    if ($status.language == 0) loadPage(DocumentationSpanish, ctx);
    else loadPage(DocumentationEnglish, ctx);
  });
  page("/users", ctx => loadPage(Users, ctx));
  page("/registration", ctx => loadPage(Registration, ctx));
  page("/credentials", ctx => loadPage(Credentials, ctx));
  page("/terms", ctx => loadPage(Terms, ctx));
  page("/privacy", ctx => loadPage(Privacy, ctx));
  page("/delete", ctx => loadPage(KillSubscription, ctx));
  page("*", ctx => loadPage(NotFound, ctx));

  page.start();
</script>

<Header />

<svelte:component this={currentPage} />
<Notification on:cancel={handleCancel} on:confirm={handleConfirm} />

<Footer />
